<template>
    <div v-if="chargeable">
        <h2>{{ $t('eventRegistration.summary.priceOverview') }}</h2>
        <div class="card">
            <div class="card-body">
                <InvoicePreview></InvoicePreview>
                <div v-if="eventData.depositAmount">
                    <div class="font-weight-bold mb-1">
                        {{ $t('eventRegistration.summary.deposit') }}
                    </div>
                    <div>
                        <span v-if="eventData.depositInPercent">
                            {{ convertToHumanNumber(eventData.depositAmount) }} %
                        </span>
                        <span v-else>
                            {{ convertToHumanNumber(eventData.depositAmount) }} {{ currencySymbol }}
                        </span>
                        <span v-if="eventData.dueDateDeposit">
                            {{ $t('eventRegistration.summary.dueDateDeposit', {days: eventData.dueDateDeposit}) }}
                        </span>
                    </div>
                    <div class="mt-2">
                        <span v-if="eventData.dueDateRemainingAmount">
                            {{ $t('eventRegistration.summary.dueDateRemainingAmount', {date: $moment(eventData.dueDateRemainingAmount).format('DD.MM.YYYY') }) }}
                        </span>
                        <span v-else-if="eventData.dueDateRemainingAmountInDays">
                            {{ $t('eventRegistration.summary.dueDateRemainingAmountInDays', {days: eventData.dueDateRemainingAmountInDays}) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InvoicePreview from "@/components/pages/registration/InvoicePreview";
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";

export default {
    name: "PriceOverview",
    components: {InvoicePreview},
    mixins: [registrationPriceMixin],
    computed: {
        chargeable() {
            return this.$store.getters['registration/chargeable']
        }
    }
}
</script>

<style scoped>

</style>
